exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.bulma .test-edit-form .tabs-container .tabs-details .show-not-allow-replay-users-button[data-v-9e37bf4e]:hover {\n  color: #2b67df;\n}\n.bulma .test-edit-form .tabs-container .tabs-details .success-text[data-v-9e37bf4e] {\n  width: 100%;\n}\n.bulma .test-edit-form .tabs-container .tabs-details .input-text[data-v-9e37bf4e] {\n  border: 1px solid #dedede;\n  box-sizing: border-box;\n  border-radius: 6px;\n  box-shadow: none;\n}", ""]);

// exports
